import { render, staticRenderFns } from "./task_list.vue?vue&type=template&id=a951760c&scoped=true"
import script from "./task_list.vue?vue&type=script&lang=js"
export * from "./task_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a951760c",
  null
  
)

export default component.exports